import { useState } from 'react';
import type { Stock } from '../../../types/stock';

export function useStockSingleSelection() {
  const [selectedStock, setSelectedStock] = useState<Stock | null>(null);

  const handleSelectStock = (stock: Stock) => {
    setSelectedStock(stock);
  };

  return {
    selectedStock,
    handleSelectStock,
  };
}
